/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

import './styles.css';

// import { Pagination } from 'swiper/modules';
import ReviewCard from '../Card/ReviewCard';

const review1 = {
  name: "Wale",
  country: "Nigeria",
  review: "I bought a used Honda Accord through them and the experience was mostly smooth. The vehicle was as described, though the auction process can be a bit overwhelming for first-timers. Their customer service was very responsive and helped answer all my questions. Just make sure you understand the fees and logistics involved. Mr Femi did well.",
  vehicle: "Honda Accord",
  img:"/assets/img/testimonial/wale.jpg"

};

const review2 = {
  name: "Annette",
  country: "Ghana",
  review: "I was a bit skeptical at first, but Auto Motor Auctions really came through. I found a 2019 Toyota Camry in great condition and got it for almost $3,000 less than market price. The support team walked me through the process and even helped arrange shipping. Definitely recommend if you know what you’re looking for.",
  vehicle: "2019 Toyota Camry",
  img:"/assets/img/testimonial/anette.jpg"
};

const review3 = {
  name: "Tunde A",
  country: "Nigeria",
  review: "I bought a Lexus RX 350 from the U.S. using Auto Motor Auctions and had it shipped to Nigeria. The team helped me navigate the entire export process, and the vehicle arrived in better shape than I expected. Very happy with the service and transparency. Will use again.",
  vehicle: "Lexus RX 350",
  img:"/assets/img/testimonial/tunde.jpg"
};

const review4 = {
  name: "Zainab J",
  country: "Sierra Leone",
  review: "Overall, my experience was good. I got a 2017 Honda CR-V through Auto Motor Auctions. It took a bit longer to clear customs than I expected, but the car was worth the wait. It was clean and drove well. Mr Femi was responsive even with the time difference.",
  vehicle: "2017 Honda CR-V"
};

const ReviewSlider = () => {
  return (
    <>
      <div className="testimonial-area bg py-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 mx-auto">
              <div className="site-heading text-center">
                <span className="site-title-tagline">
                  <i className="flaticon-drive"></i> Testimonials
                </span>
                <h2 className="site-title">
                  What Our Client <span>Say</span>
                </h2>
                <div className="heading-divider"></div>

                <Swiper
                  slidesPerView={3}
                  spaceBetween={30}
                  // pagination={{ clickable: true }}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                    },
                    640: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                    },
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 20,
                    },
                    1024: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                  }}
                  // modules={[Pagination]}
                  className="ReviewSlider"
                >
                  <SwiperSlide>
                    <ReviewCard data={review1}/>
                  </SwiperSlide>
                  <SwiperSlide>
                    <ReviewCard data={review2} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ReviewCard data={review3} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ReviewCard data={review4} />
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewSlider;
